import {
  FinancialOpex,
  FinancialOpexType,
  FinOpexPropName
} from '../../../../models/project/financial/financial-opex.model';
import { GenericErrors, ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import { ValidationInterface } from '../../validation.interface';

export class FinancialOpexValidation implements ValidationInterface {
  /** The current financial opex obj that is being validated */
  opex: FinancialOpex;

  /**
   * Sets the opex obj that will be used for validation
   * @param opex will be used to set the current opex obj
   * @param isProjectInput
   */
  constructor(opex: FinancialOpex, private isProjectInput?: boolean) {
    if (!opex) throw Error('invalid opex item provided for validation');
    this.opex = new FinancialOpex(opex);
  }

  /**
   * Get a validation unit containing the validation data for the current opex obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.opex) throw Error('unable to validate opex');
    const validationUnit = new ProjectValidationUnit();
    if (this.opex.name) {
      validationUnit.setValid(FinOpexPropName.name);
    } else {
      validationUnit.setInvalid(FinOpexPropName.name,
        [GenericErrors.MissingName]);
    }
    if (this.opex.type) {
      validationUnit.setValid(FinOpexPropName.type);
      validationUnit.addModuleResults(
        new UnitValueValidation(this.opex.cost).getValidation(),
        FinOpexPropName.cost
      );
      if (this.opex.type === FinancialOpexType.MAJOR_MAINT) {
        validationUnit.addModuleResults(
          new UnitValueValidation(this.opex.frequencyOfOccurrence).getValidation(),
          FinOpexPropName.frequencyOfOccurrence
        );
      } else {
        validationUnit.addModuleResults(
          new UnitValueValidation(this.opex.period).getValidation(),
          FinOpexPropName.period
        );
      }
      // TODO add this line when duration is required for simulation
      // validationUnit.addModuleResults(this.duration.getValid(), FinOpexPropName.Duration);
      if (this.opex.type !== FinancialOpexType.MAJOR_MAINT && !this.isProjectInput) {
        validationUnit.addModuleResults(
          new UnitValueValidation(this.opex.cpi).getValidation(),
          FinOpexPropName.cpi
        );
      }
    } else {
      validationUnit.setInvalid(FinOpexPropName.type,
        [GenericErrors.MissingType]);
    }
    validationUnit.addModuleResults(
      new UnitValueValidation(this.opex.cost).getValidation(),
      FinOpexPropName.cost
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current financial opex obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
